import { z } from 'zod';
import { isoDateSchema } from './common';

/** `GET /api/fx/rates?date=YYYY-MM-DD` (date optional = latest). ECB rates via frankfurter. */
export const fxRatesQuerySchema = z.object({ date: isoDateSchema.optional() });
export type FxRatesQuery = z.infer<typeof fxRatesQuerySchema>;

/**
 * Same shape as `RateTable` in `@split/core`: `rates[X]` = units of X per 1 `base`
 * (decimal strings). Use `getRate(table, from, to)` / `convertWithTable` from core.
 */
export const rateTableSchema = z.object({
  base: z.string(),
  date: isoDateSchema,
  rates: z.record(z.string(), z.string()),
});
export type RateTableDto = z.infer<typeof rateTableSchema>;
